var pacdoraUtils = {
  safeQuerySelector: function (selector, parent) {
    if (!selector) return null
    try {
      return (parent || document).querySelector(selector)
    } catch (error) {
      console.warn('Invalid selector: ' + selector, error)
      return null
    }
  },

  safeQuerySelectorAll: function (selector, parent) {
    if (!selector) return []
    try {
      return Array.from((parent || document).querySelectorAll(selector))
    } catch (error) {
      console.warn('Invalid selector: ' + selector, error)
      return []
    }
  },

  getEventPath: function (event) {
    return (event.composedPath && event.composedPath()) || event.path || []
  },

  // className is a string on HTML elements but an SVGAnimatedString on SVG ones,
  // so guard the type before calling includes().
  classNameIncludes: function (item, token) {
    return item && typeof item.className === 'string' && item.className.includes(token)
  },

  // "front,back" + "#fff" -> { front: { color: '#fff' }, back: { color: '#fff' } }
  parseBgComponents: function (bgComponentStr, bgColor) {
    if (!bgComponentStr || !bgColor) return {}
    const result = {}
    bgComponentStr
      .split(',')
      .map((comp) => comp.trim())
      .filter((comp) => comp)
      .forEach((component) => {
        result[component] = { color: bgColor }
      })
    return result
  }
}

var createPacdora3d = () => {
  const imgs = document.querySelectorAll('img')
  const matchedElement = Array.from(imgs).find((el) => el.src.match(/.*.pacdora.3d.*/))
  console.log('matchedElement', matchedElement)
  if (matchedElement) {
    window.addEventListener(
      'click',
      (e) => {
        if (e.isTrusted === false) return

        const path = pacdoraUtils.getEventPath(e)

        const pacdoraContainer = path.find(
          (item) =>
            pacdoraUtils.classNameIncludes(item, 'pacdora-container') ||
            pacdoraUtils.classNameIncludes(item, 'pacdora-box')
        )
        if (pacdoraContainer) {
          e.stopPropagation()
        }
        const switchContainer = path.find((item) =>
          pacdoraUtils.classNameIncludes(item, 'pacdora-switch-item')
        )
        if (switchContainer) {
          const switchItem = e.target
          console.log(switchItem)
          let type = switchItem.dataset.type
          // If the type cannot be found, look up the DOM to find data-type.
          if (!type) {
            let parentElement = switchItem.parentElement
            while (parentElement && !type) {
              type = parentElement.dataset.type
              // If an element of class 'pacdora-switch-item' is found, stop searching.
              if (pacdoraUtils.classNameIncludes(parentElement, 'pacdora-switch-item')) {
                break
              }
              parentElement = parentElement.parentElement
            }
          }
          onSwitch2DAnd3D(type)
        }
      },
      true
    )
    window.addEventListener(
      'mousedown',
      (e) => {
        const path = pacdoraUtils.getEventPath(e)
        const pacdoraContainer = path.find((item) =>
          pacdoraUtils.classNameIncludes(item, 'pacdora-box-info')
        )
        if (pacdoraContainer) {
          e.stopPropagation()
        }
      },
      true
    )
    const div = document.createElement('div')
    Object.assign(div.style, { width: '100%', height: '100%' })
    div.className = 'pacdora-box-info'
    const loadingDiv = document.createElement('div')
    loadingDiv.className = 'pacdora-box-loading'
    div.appendChild(loadingDiv)
    const D3ContainerDiv = document.createElement('div')
    D3ContainerDiv.className = 'pacdora-box-info-slider'
    const firstDiv = document.createElement('div')
    firstDiv.className = 'pacdora-box-info-item'

    // Create the switch element
    const switchDiv = document.createElement('div')
    switchDiv.className = 'pacdora-d3-and-d2-switch'
    switchDiv.innerHTML = `
        <div class="pacdora-switch-item active" data-type="3d">3D</div>
        <div class="pacdora-switch-item" data-type="dieline">Dieline</div>
      `

    // Use addEventListener to bind events
    const switchItems = switchDiv.querySelectorAll('.pacdora-switch-item')
    switchItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        const type = e.target.dataset.type
        onSwitch2DAnd3D(type, e)
      })
    })

    // Replace the original image
    matchedElement.parentNode?.insertBefore(div, matchedElement)
    matchedElement.style.display = 'none'
    // Create 3D container
    const d3Div = document.createElement('div')
    d3Div.className = 'd3'
    d3Div.dataset.pacdoraUi = '3d'
    d3Div.dataset.pacdoraId = 'd3'
    // The SDK now renders the open/close slider itself
    d3Div.dataset.showSlider = true
    firstDiv.appendChild(d3Div)
    // Create the dieline container
    const dielineDiv = document.createElement('div')
    dielineDiv.className = 'dieline'
    dielineDiv.dataset.pacdoraUi = 'dieline'
    dielineDiv.dataset.notUseScience = true
    const secondDiv = document.createElement('div')
    secondDiv.className = 'pacdora-box-info-item'
    secondDiv.appendChild(dielineDiv)
    D3ContainerDiv.appendChild(firstDiv)
    D3ContainerDiv.appendChild(secondDiv)
    div.appendChild(D3ContainerDiv)
    div.appendChild(switchDiv)
  }
}
async function interceptCart() {
  // Modify the native fetch method to intercept API calls for adding to the shopping cart.
  if (!window.originalFetch && window.fetch) {
    window.originalFetch = window.fetch
    window.fetch = async function (url, options) {
      console.log(url, options)
      // Check if it is a request to add to the shopping cart.
      if (typeof url === 'string' && url.includes('/cart/add') && options && options.body) {
        let pacdoraObj = {
          projectId: undefined,
          image3D: ''
        }
        try {
          if (window.Pacdora) {
            await Pacdora._waitProjectCreate()
            let { id, screenshot } = await Pacdora.getBoxInfo()
            console.log('Pacdora project id:', id)
            pacdoraObj.projectId = id
            pacdoraObj.image3D = 'https:' + screenshot
          }
        } catch (error) {
          console.error('Error getting project ID in fetch interceptor:', error)
        }

        // If the request body is FormData, add the project ID
        if (options.body instanceof FormData) {
          options.body.append('properties[pacdora-project-id]', pacdoraObj.projectId)
          if (pacdoraObj.image3D) {
            options.body.append('properties[pacdora-image3D]', pacdoraObj.image3D)
          }
          console.log('Added project ID to FormData')
        }
        // If the request body is a string (e.g. JSON or URL encoded), parse and add the project ID
        else if (typeof options.body === 'string') {
          try {
            // Try to parse as JSON
            const bodyObj = JSON.parse(options.body)
            if (!bodyObj.properties) bodyObj.properties = {}
            bodyObj.properties['pacdora-project-id'] = pacdoraObj.projectId
            if (pacdoraObj.image3D) {
              bodyObj.properties['pacdora-image3D'] = pacdoraObj.image3D
            }
            options.body = JSON.stringify(bodyObj)
            console.log('Added project ID to JSON body')
          } catch (e) {
            // Not JSON, possibly URL encoded form data
            try {
              const bodyParams = new URLSearchParams(options.body)
              bodyParams.append('properties[pacdora-project-id]', pacdoraObj.projectId)
              if (pacdoraObj.image3D) {
                bodyParams.append('properties[pacdora-image3D]', pacdoraObj.image3D)
              }
              options.body = bodyParams.toString()
              console.log('Added project ID to URL encoded body')
            } catch (urlError) {
              console.error('Failed to parse URL encoded body:', urlError)
            }
          }
        }
      }

      // Continue the original fetch call
      return window.originalFetch.apply(this, arguments)
    }
    console.log('Fetch method intercepted')
  }
}

// Look up one of our PRODUCT_DATA variants by Shopify variant id.
function findVariantById(variantId) {
  if (!variantId) return null
  return window.PRODUCT_DATA.variants.find((v) => v.id == variantId) || null
}

// The theme keeps the authoritative selection in a JSON script tag inside
// <variant-selects> and rewrites it on every variant change.
function readThemeSelectedVariant() {
  const node = pacdoraUtils.safeQuerySelector('variant-selects [data-selected-variant]')
  if (!node) return null
  try {
    const parsed = JSON.parse(node.textContent)
    return parsed && parsed.id ? findVariantById(parsed.id) : null
  } catch (error) {
    console.warn('Unable to parse the theme selected variant', error)
    return null
  }
}

// Collect the chosen option values from a form. The variant picker renders
// either <select> elements (dropdown) or radio inputs (button/swatch), so both
// have to be read, in DOM order, to line up with variant.options.
function readSelectedOptionValues(form) {
  const values = []
  pacdoraUtils
    .safeQuerySelectorAll('select, fieldset', form)
    .forEach((el) => {
      if (el.tagName === 'SELECT') {
        const selected = el.options[el.selectedIndex]
        if (selected) values.push(selected.value)
        return
      }
      const checked = el.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked')
      if (checked) values.push(checked.value)
    })
  return values
}

// Get the currently selected variant
function getSelectedVariant() {
  const themeVariant = readThemeSelectedVariant()
  if (themeVariant) return themeVariant

  const form_selector = window.PRODUCT_DATA.form_selector
  const form = pacdoraUtils.safeQuerySelector(form_selector)
  if (!form) {
    if (form_selector) console.warn('Form element not found:', form_selector)
    return null
  }

  const selectedOptions = readSelectedOptionValues(form)
  if (selectedOptions.length === 0) {
    console.warn('No option inputs found in', form_selector)
    return null
  }

  const variant = window.PRODUCT_DATA.variants.find((v) => {
    const variantOptions = (v.options || []).map((opt) => opt.name)
    return (
      selectedOptions.length === variantOptions.length &&
      selectedOptions.every((option, index) => option == variantOptions[index])
    )
  })

  if (!variant) console.warn('No variant matches options', selectedOptions)
  return variant || null
}

var currentModelOrTemplate = null
var lastVariant = null
var Pacdora_isMobile = window.innerWidth < 980

var setCustom = async (selectedVariant) => {
  const variantData = selectedVariant || getSelectedVariant()
  if (!variantData) {
    console.warn('No variant data found')
    return
  }
  // A variant pointing at a different model/template needs a whole new scene,
  // which onVariantChanged has already handled before delegating here — so at
  // this point we only ever apply size/material/background to the current one.
  console.log('Selected variant from form:', variantData)
  console.log('pacdora size:', variantData)
  const dimension = {
    width: undefined,
    height: undefined,
    length: undefined
  }
  const materialSetting = {
    materialName: undefined,
    materialImage: undefined
  }
  if (variantData.metafields.material && variantData.metafields.material.trim() !== '') {
    materialSetting.materialName = variantData.name
    materialSetting.materialImage = variantData.metafields.material
    await Pacdora.setMaterial({
      name: variantData.name,
      image: variantData.metafields.material,
      async: false
    })
  }
  let size = variantData.metafields.size
  if (size) {
    // Handle both 'x' and '*' cases
    const dimensions = size
      .toLowerCase() // Convert to lowercase
      .replace(/[x*]/g, '*') // Replace all x and * with *
      .split('*')
      .map((str) => str.trim())
      .map(Number)
      .filter((num) => !isNaN(num))

    if (dimensions.length === 3) {
      const [length, width, height] = dimensions
      console.log('Size dimensions:', { length, width, height })
      dimension.length = length
      dimension.width = width
      dimension.height = height
      await Pacdora.setSize({
        length,
        width,
        height,
        async: false
      })
    }
  }
  if (
    (dimension.length && dimension.width && dimension.height) ||
    (materialSetting.materialName && materialSetting.materialImage)
  ) {
    await Pacdora.update()
  }

  const bgChanged =
    !lastVariant ||
    lastVariant.metafields.bg !== variantData.metafields.bg ||
    lastVariant.metafields.bg_component !== variantData.metafields.bg_component
  if (bgChanged) {
    const bgComponentList = pacdoraUtils.parseBgComponents(
      variantData.metafields.bg_component,
      variantData.metafields.bg
    )
    if (Object.keys(bgComponentList).length > 0) {
      await Pacdora.setCustomMaterial(bgComponentList, {
        enablePartNameMatching: true
      })
    }
  }
  lastVariant = variantData
}

// A variant switch either needs a brand new scene (the variant points at a
// different model/template) or just an in-place size/material/background
// update on the current one.
async function onVariantChanged(variantData) {
  if (!variantData) return

  let useType = null
  if (variantData.metafields.modelId) {
    useType = 'model'
  } else if (variantData.metafields.templateId) {
    useType = 'template'
  }

  const nextId = variantData.metafields.modelId || variantData.metafields.templateId
  if (useType && currentModelOrTemplate !== nextId) {
    const loadingDiv = pacdoraUtils.safeQuerySelector('.pacdora-box-loading')
    if (loadingDiv) loadingDiv.style.display = 'block'
    await createPacdoraScene(useType, variantData)
    if (loadingDiv) loadingDiv.style.display = 'none'
    return
  }

  await setCustom(variantData)
}

// Prefer the theme's own variant-change broadcast; fall back to watching the
// option inputs directly for themes/templates that do not publish it.
// Guarded because the theme editor re-runs createPacdora on section reload.
var pacdoraVariantListenersBound = false
function listenToVariantChanges() {
  if (pacdoraVariantListenersBound) return
  pacdoraVariantListenersBound = true

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, async (event) => {
      const variant = event?.data?.variant
      if (!variant) return
      window.PRODUCT_DATA.current_variant_id = variant.id
      await onVariantChanged(findVariantById(variant.id))
    })
  }

  document.addEventListener('change', async function (event) {
    const project_selector = window.PRODUCT_DATA.project_selector
    if (project_selector) {
      const projectInputs = pacdoraUtils.safeQuerySelectorAll(project_selector)
      const matched = projectInputs.find((item) => item === event.target)
      if (matched) {
        await setProject(matched.value)
        return
      }
    }

    const form = pacdoraUtils.safeQuerySelector(window.PRODUCT_DATA.form_selector)
    if (form && form.contains(event.target)) {
      await onVariantChanged(getSelectedVariant())
    }
  })
}
var MAX_RETRIES = 3
// The SDK is now served from a single, unversioned endpoint keyed by app id.
var loadPacdoraScriptWithRetry = (retries = 0) => {
  return new Promise((resolve, reject) => {
    if (window.Pacdora) {
      resolve()
      return
    }
    const script = document.createElement('script')
    script.src = `https://api.pacdora.com/sdk/Pacdora.js?app_id=${window.PACDORA_CONFIG.appId}`
    script.async = true
    const retryOrReject = (error) => {
      if (retries < MAX_RETRIES) {
        console.log(`retry loading Pacdora sdk... (${retries + 1}/${MAX_RETRIES})`)
        loadPacdoraScriptWithRetry(retries + 1)
          .then(resolve)
          .catch(reject)
      } else {
        reject(error)
      }
    }
    script.onload = () => {
      if (window.Pacdora) {
        resolve()
      } else {
        retryOrReject(new Error('Pacdora sdk loaded but window.Pacdora is undefined'))
      }
    }
    script.onerror = () => {
      retryOrReject(new Error('Failed to load Pacdora sdk'))
    }
    document.body.appendChild(script)
  })
}
var PacdoraType = ''
var createPacdora = async () => {
  interceptCart()
  const appId = window.PACDORA_CONFIG.appId
  if (!appId) {
    showMessage('No app id found')
    return
  }
  const selectedVariant = window.PRODUCT_DATA.current_variant_id
  const variantData = window.PRODUCT_DATA.variants.find((v) => v.id == selectedVariant)
  const modelId = variantData.metafields.modelId
    ? variantData.metafields.modelId
    : window.PRODUCT_DATA.pacdora_model_id
  const templateId = variantData.metafields.templateId
    ? variantData.metafields.templateId
    : window.PRODUCT_DATA.pacdora_template_id
  if (!modelId && !templateId) {
    showMessage('No model or template id found')
    return
  }
  let useType = 'model'
  if (variantData.metafields.modelId) {
    useType = 'model'
  } else if (variantData.metafields.templateId) {
    useType = 'template'
  } else if (window.PRODUCT_DATA.pacdora_model_id) {
    useType = 'model'
  } else if (window.PRODUCT_DATA.pacdora_template_id) {
    useType = 'template'
  }
  console.log('Selected variant from form:', selectedVariant)
  console.log(modelId, appId)
  const imgs = document.querySelectorAll('img')
  const matchedElement = Array.from(imgs).find((el) => el.src.match(/.*.pacdora.3d.*/))
  if (matchedElement) {
    createPacdora3d()
  }
  try {
    await loadPacdoraScriptWithRetry()
  } catch (err) {
    console.error('Pacdora sdk load failed:', err)
    showMessage('Pacdora sdk load failed')
    return
  }
  try {
    console.log('pacdora size:', variantData)

    await Pacdora.init({
      appId: appId,
      isDelay: true,
      quotation: false,
      customDefault: false,
      theme: '#333333'
    })
    await createPacdoraScene(useType, variantData, modelId, templateId)

    Pacdora.$on('3d:init', () => {
      console.log('init-complete')
      const loadingDiv = document.querySelector('.pacdora-box-loading')
      if (loadingDiv) {
        loadingDiv.style.display = 'none'
      }
    })
    const loadingBtnDiv = document.querySelectorAll('.pac-loading')
    if (loadingBtnDiv) {
      loadingBtnDiv.forEach((item) => {
        item.style.display = 'none'
      })
    }
    Pacdora.$on('download:start', () => {
      const downloadEle = document.querySelector('#pacdora-download')
      if (downloadEle) {
        downloadEle.querySelector('.pac-text').innerText = 'Downloading...'
      }
    })
    Pacdora.$on('download:success', () => {
      const downloadEle = document.querySelector('#pacdora-download')
      if (downloadEle) {
        downloadEle.innerText = 'Download success'
        setTimeout(() => {
          downloadEle.innerText = 'Download the Dieline'
        }, 1000)
      }
    })
    Pacdora.$on('download:fail', () => {
      const downloadEle = document.querySelector('#pacdora-download')
      if (downloadEle) {
        downloadEle.innerText = 'Download failed'
        setTimeout(() => {
          downloadEle.innerText = 'Download the Dieline'
        }, 1000)
      }
    })
    const designButton = document.querySelector('#pacdora-design-btn')
    if (designButton) {
      mobileBtnEventHijacking(designButton)
      designButton.addEventListener('click', () => {
        const loadingEle = designButton.querySelector('.pac-loading')
        if (loadingEle) {
          loadingEle.style.display = 'block'
        }
      })
    }
    Pacdora.$on('design:opened', () => {
      const loadingEle = document.querySelector('#pacdora-design-btn .pac-loading')
      if (loadingEle) {
        loadingEle.style.display = 'none'
      }
    })
  } catch (err) {
    console.warn('Pacdora error:', err)
  }
  listenToVariantChanges()
}
async function setProject(value) {
  let useType = 'model'
  const variantData = window.PRODUCT_DATA.variants.find((v) => {
    return v.name.includes(value)
  })
  if (!variantData) {
    return
  }
  if (!variantData.metafields.modelId && !variantData.metafields.templateId) {
    return
  }
  if (variantData.metafields.modelId) {
    useType = 'model'
  } else if (variantData.metafields.templateId) {
    useType = 'template'
  }
  const loadingDiv = document.querySelector('.pacdora-box-loading')
  if (loadingDiv) {
    loadingDiv.style.display = 'block'
  }
  await createPacdoraScene(useType, variantData)
}
function initPacdora() {
  PacdoraType = 'basic'
  console.log('initPacdora')
  document.addEventListener('DOMContentLoaded', async () => {
    console.log('DOMContentLoaded')
    await createPacdora()
  })
}
var createPacdoraPlus = async () => {
  console.log('createPacdoraPlus')
  interceptCart()

  const selectedVariant = window.PRODUCT_DATA.current_variant_id
  const variantData = window.PRODUCT_DATA.variants.find((v) => v.id == selectedVariant)
  const modelId = variantData.metafields.modelId
    ? variantData.metafields.modelId
    : window.PRODUCT_DATA.pacdora_model_id
  const templateId = variantData.metafields.templateId
    ? variantData.metafields.templateId
    : window.PRODUCT_DATA.pacdora_template_id

  const materialTemplateId = variantData.metafields.materialTemplateId
  if (!modelId && !templateId) {
    showMessage('No model or template id found')
    return
  }

  const appId = window.PACDORA_CONFIG.appId
  if (!appId) {
    showMessage('No app id found')
    return
  }
  createPacdora3d()

  try {
    await loadPacdoraScriptWithRetry()
  } catch (err) {
    console.error('Pacdora sdk load failed:', err)
    showMessage('Pacdora sdk load failed')
    return
  }

  // The advanced (plus) features now live in the same Pacdora namespace,
  // there is no separate Pacdora-plus bundle to pull in and register.
  console.log('Pacdora initialized')
  await Pacdora.init({
    appId: appId,
    isDelay: true,
    quotation: false,
    customDefault: false
  })

  const advancedSetting = {}
  if (materialTemplateId) {
    advancedSetting.blankSettingId = materialTemplateId
  }
  console.log('advancedSetting', advancedSetting)

  const plusSceneParams = { doneBtn: 'Save', advancedSetting }
  const plusBgComponents = Object.assign(
    {},
    pacdoraUtils.parseBgComponents(
      window.PRODUCT_DATA.pacdora_bg_component,
      window.PRODUCT_DATA.pacdora_bg
    ),
    pacdoraUtils.parseBgComponents(
      variantData.metafields.bg_component,
      variantData.metafields.bg
    )
  )
  if (Object.keys(plusBgComponents).length > 0) {
    plusSceneParams.customMaterial = {
      option: plusBgComponents,
      config: { enablePartNameMatching: true }
    }
  }

  if (modelId) {
    plusSceneParams.modelId = modelId
  } else if (templateId) {
    plusSceneParams.templateId = templateId
  }
  if (plusSceneParams.modelId || plusSceneParams.templateId) {
    currentModelOrTemplate = plusSceneParams.modelId || plusSceneParams.templateId
    lastVariant = variantData
    await Pacdora.createScene(plusSceneParams)
  }

  Pacdora.$on('3d:init', () => {
    console.log('init-complete')
    const loadingDiv = document.querySelector('.pacdora-box-loading')
    if (loadingDiv) {
      loadingDiv.style.display = 'none'
    }
    const skeletonSelects = document.querySelector('.pacdora-skeleton-selects')
    const selectorContent = document.querySelector('.pacdora-selector-content')
    if (skeletonSelects) {
      skeletonSelects.style.display = 'none'
    }
    if (selectorContent) {
      selectorContent.style.display = 'block'
    }
    const selectContent = document.querySelector('.pacdora-selector-content')
    if (selectContent) {
      selectContent.style.minHeight = '0px'
    }
    const selectorBox = document.querySelector('.pacdora-selector-box')
    if (selectorBox) {
      selectorBox.style.opacity = '1'
      selectorBox.style.height = 'fit-content'
    }
  })
  const loadingBtnDiv = document.querySelectorAll('.pac-loading')
  if (loadingBtnDiv) {
    loadingBtnDiv.forEach((item) => {
      item.style.display = 'none'
    })
  }
  const contactButton = document.querySelector('#pacdora-contact-button')
  if (contactButton) {
    contactButton.addEventListener('click', async () => {
      Pacdora.openPlusContactDialog({
        visible: true,
        canCancel: true,
        confirm: (result) => {
          console.log('confirm ===>', result)
        }
      })
    })
    contactButton.style.backgroundColor = '#000'
    contactButton.style.color = '#fff'
    contactButton.style.cursor = 'pointer'
    Pacdora.$on('contact-dialog:loading', () => {
      const loadingEle = contactButton.querySelector('.pac-loading')
      if (loadingEle) {
        loadingEle.style.display = 'block'
      }
    })
    Pacdora.$on('contact-dialog:complete', () => {
      const loadingEle = contactButton.querySelector('.pac-loading')
      if (loadingEle) {
        loadingEle.style.display = 'none'
      }
    })
  }
  const buyButton = document.querySelector('#pacdora-buy-button')
  if (buyButton) {
    buyButton.addEventListener('click', async () => {
      await createShopifyOrder()
    })
    buyButton.style.backgroundColor = '#000'
    buyButton.style.color = '#fff'
    buyButton.style.cursor = 'pointer'
  }
  const designButton = document.querySelector('#pacdora-advanced-design')
  if (designButton) {
    mobileBtnEventHijacking(designButton)
    designButton.addEventListener('click', () => {
      const loadingEle = designButton.querySelector('.pac-loading')
      if (loadingEle) {
        loadingEle.style.display = 'block'
      }
    })
  }
  Pacdora.$on('download:start', () => {
    const downloadEle = document.querySelector('#pacdora-download')
    if (!downloadEle) return
    downloadEle.style.cursor = 'not-allowed'
    const downloadLoadingEle = downloadEle.querySelector('.pac-loading')
    const textEle = downloadEle.querySelector('.pac-text')
    if (textEle) {
      textEle.innerText = 'Downloading...'
    }
    if (downloadLoadingEle) {
      downloadLoadingEle.style.display = 'block'
    }
  })
  Pacdora.$on('download:success', () => {
    const downloadEle = document.querySelector('#pacdora-download')
    if (!downloadEle) return
    downloadEle.style.cursor = 'pointer'
    const textEle = downloadEle.querySelector('.pac-text')
    if (textEle) {
      textEle.innerText = 'Download success'
      setTimeout(() => {
        textEle.innerText = 'Download Dieline'
      }, 1000)
    }
    const downloadLoadingEle = downloadEle.querySelector('.pac-loading')
    if (downloadLoadingEle) {
      downloadLoadingEle.style.display = 'none'
    }
  })
  Pacdora.$on('download:fail', () => {
    const downloadEle = document.querySelector('#pacdora-download')
    if (downloadEle) {
      downloadEle.innerText = 'Download failed'
      setTimeout(() => {
        downloadEle.innerText = 'Download the Dieline'
      }, 1000)
    }
  })
  Pacdora.$on('design:opened', () => {
    const loadingEle = document.querySelector('#pacdora-advanced-design .pac-loading')
    if (loadingEle) {
      loadingEle.style.display = 'none'
    }
  })
  // "Buy now" inside the designer is delegated back to the Shopify order flow.
  Pacdora.$on('design:save', async (data) => {
    if (data.type === 'buyNow') {
      await createShopifyOrder()
      return false
    }
  })

  listenToVariantChanges()
}
async function createShopifyOrder() {
  const buyLoading = document.querySelector('#pacdora-buy-button .pac-loading')
  if (buyLoading) {
    buyLoading.style.display = 'block'
  }
  console.log('createShopifyOrder')
  await Pacdora._waitProjectCreate()
  await Pacdora.priceReady()
  let unitPrice = 0
  let quantity = 1
  const variantAttributes = []
  const data = Pacdora.getAdvancedData()
  const quantityData = Pacdora.getQuantityData()
  if (data) {
    data.forEach((item) => {
      variantAttributes.push({
        key: item.type,
        value: item.selectedName
      })
    })
  }
  if (quantityData) {
    unitPrice =
      quantityData.options.find((item) => item.quantity === quantityData.quantity)?.unit_price ||
      quantityData.price / quantityData.quantity ||
      0
    quantity = quantityData.quantity || 1
  }
  const { screenshot, id } = await Pacdora.getBoxInfo()
  variantAttributes.push({
    key: 'image3D',
    value: 'https:' + screenshot
  })
  variantAttributes.push({
    key: 'projectId',
    value: id.toString()
  })
  const postData = {
    variantId: window.PRODUCT_DATA.current_variant_id.toString(),
    unitPrice: unitPrice,
    quantity: quantity,
    variantAttributes: variantAttributes
  }
  try {
    let response = await fetch('https://api.pacdora.com/open/v1/shopify/order', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('api-token')
      },
      body: JSON.stringify(postData)
    })
    let res = await response.json()
    if (res.code === 200) {
      window.location.href = res.data.url
    } else {
      showMessage('Create order failed')
    }
  } catch (err) {
    console.error('createShopifyOrder error:', err)
    showMessage('Create order failed')
  } finally {
    if (buyLoading) {
      buyLoading.style.display = 'none'
    }
  }
}
async function initPacdoraPlus() {
  PacdoraType = 'plus'
  document.addEventListener('DOMContentLoaded', async () => {
    await createPacdoraPlus()
  })
}
function onSwitch2DAnd3D(type, event) {
  console.log('onSwitch', type)
  event?.stopPropagation()
  event?.preventDefault()
  const switchItems = document.querySelectorAll('.pacdora-switch-item')
  const boxInfo = document.querySelector('.pacdora-box-info-slider')
  if (type === '3d') {
    switchItems[0].className = 'pacdora-switch-item active'
    switchItems[1].className = 'pacdora-switch-item'
    boxInfo.style.transform = 'translateX(0)'
  } else if (type === 'dieline') {
    switchItems[0].className = 'pacdora-switch-item'
    switchItems[1].className = 'pacdora-switch-item active'
    boxInfo.style.transform = 'translateX(-100%)'
  }
}
// The designer needs a pointer and a large canvas, so on phones we intercept
// the click before the SDK opens it and explain why instead.
function mobileBtnEventHijacking(dom) {
  if (!dom || !Pacdora_isMobile) return
  dom.addEventListener(
    'click',
    (e) => {
      showMessage('Please use a desktop browser for the best design experience.')
      e.stopPropagation()
      e.preventDefault()
    },
    { capture: true }
  )
}

function showMessage(message, duration = 2000) {
  const div = document.createElement('div')
  div.textContent = message
  div.style.cssText = `
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(0,0,0,0.7);
        color: white;
        padding: 10px 20px;
        border-radius: 4px;
        z-index: 9999;
    `
  document.body.appendChild(div)

  setTimeout(() => {
    div.remove()
  }, duration)
}
document.addEventListener('shopify:section:load', async (event) => {
  if (PacdoraType === 'basic') {
    await createPacdora()
  } else if (PacdoraType === 'plus') {
    await createPacdoraPlus()
  }
})

async function createPacdoraScene(useType, variantData, modelId, templateId) {
  const dimension = {
    width: undefined,
    height: undefined,
    length: undefined
  }
  const materialSetting = {
    materialName: undefined,
    materialImage: undefined
  }
  if (variantData.metafields.material && variantData.metafields.material.trim() !== '') {
    materialSetting.materialId = 44
    materialSetting.materialName = variantData.name
    materialSetting.materialImage = variantData.metafields.material
  }
  if (variantData.metafields.materialTemplateId) {
    materialSetting.blankSettingId = variantData.metafields.materialTemplateId
  }
  let size = variantData.metafields.size
  if (size) {
    const dimensions = size
      .toLowerCase() // Convert to lowercase
      .replace(/[x*]/g, '*') // Replace all x and * with *
      .split('*')
      .map((str) => str.trim())
      .map(Number)
      .filter((num) => !isNaN(num))

    if (dimensions.length === 3) {
      const [length, width, height] = dimensions
      console.log('Size dimensions:', { length, width, height })
      dimension.length = length
      dimension.width = width
      dimension.height = height
    }
  }
  if (!useType || !variantData) {
    console.warn('Missing parameters for creating scene')
    return null
  }

  // Product level background first, then the variant's, so a variant can
  // override the colour of any component it names.
  const bgComponentList = Object.assign(
    {},
    pacdoraUtils.parseBgComponents(
      window.PRODUCT_DATA.pacdora_bg_component,
      window.PRODUCT_DATA.pacdora_bg
    ),
    pacdoraUtils.parseBgComponents(
      variantData.metafields.bg_component,
      variantData.metafields.bg
    )
  )

  // Size and material are now passed through advancedSetting instead of
  // being top level scene parameters.
  let sceneParams = {
    doneBtn: 'Save',
    advancedSetting: {
      ...materialSetting,
      width: dimension.width,
      height: dimension.height,
      length: dimension.length
    },
    packagingColors: ['#ff0000', '#00ff00', '#0000ff', '#893829']
  }

  if (useType === 'model' && variantData.metafields.modelId) {
    sceneParams.modelId = variantData.metafields.modelId
  } else if (useType === 'template' && variantData.metafields.templateId) {
    sceneParams.templateId = variantData.metafields.templateId
  } else if (useType === 'model' && modelId) {
    sceneParams.modelId = modelId
  } else if (useType === 'template' && templateId) {
    sceneParams.templateId = templateId
  } else {
    console.warn('Invalid useType or missing ID')
    return null
  }
  if (Object.keys(bgComponentList).length > 0) {
    sceneParams.customMaterial = {
      option: bgComponentList,
      config: {
        enablePartNameMatching: true
      }
    }
  }

  try {
    if (variantData.featured_image) {
      // 等待shopify ssr模板返回
      await requestBlocker.waitForRequest()
      await replaceFeaturedImage()
    }
    currentModelOrTemplate = sceneParams.modelId || sceneParams.templateId
    lastVariant = variantData
    const id = await Pacdora.createScene(sceneParams)

    return id
  } catch (err) {
    console.error('Error creating scene:', err)
    const loadingDiv = document.querySelector('.pacdora-box-loading')
    if (loadingDiv) {
      loadingDiv.style.display = 'none'
    }
    return null
  }
}
function replaceFeaturedImage() {
  // 找到class为pacdora-box-info的dom，移动到第一个标签名为slider-component的dom下面的ui中的第一个li dom中
  let pacdoraBoxInfo = document.querySelector('.pacdora-box-info')
  if (!pacdoraBoxInfo) {
    createPacdora3d()
    pacdoraBoxInfo = document.querySelector('.pacdora-box-info')
  }
  if (!pacdoraBoxInfo) return

  const mediaContainer = pacdoraUtils.safeQuerySelector(
    'slider-component ul li .product__media'
  )
  if (!mediaContainer) {
    console.warn('Product media gallery not found, leaving the 3D box in place')
    return
  }
  mediaContainer.appendChild(pacdoraBoxInfo)
  const imgPreview = mediaContainer.querySelector('img')
  if (imgPreview) imgPreview.style.display = 'none'
}
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
class RequestBlocker {
  constructor(targetUrl) {
    this.targetUrl = targetUrl || 'no-target-url';
    this.resetState()
    this.setupObserver();
  }

  setupObserver() {
    const pacObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        // 捕获当前模板的请求路径
        if(entry.entryType === 'resource' && entry.name.includes(this.targetUrl) && !entry.name.endsWith('.js')){
          const isSuccess = this.checkRequestSuccess(entry);
          if (isSuccess && this.isBlocking && this.resolveFunctionArray.length) {
            const lastResolveFunction = this.resolveFunctionArray.pop();
            lastResolveFunction();
            this.resetState();
          }
        }
      });
    });

    pacObserver.observe({ entryTypes: ['resource'] });
  }

  checkRequestSuccess(entry) {
    return entry.responseEnd > 0 && entry.responseStart > 0;
  }

  async waitForRequest() {
    if (this.isBlocking) {
      return this.currentPromise;
    }
    this.isBlocking = true;
    this.currentPromise = new Promise((resolve) => {
      this.resolveFunctionArray.push(resolve);
    });

    return this.currentPromise;
  }

  resetState() {
    this.isBlocking = false;
    this.currentPromise = null;
    this.resolveFunctionArray = [];
  }

}

const pagePathName = window.location.pathname;
const requestBlocker = new RequestBlocker(pagePathName);

// This file is deferred, so it runs after the inline PRODUCT_DATA block that
// main-product.liquid renders, but still before DOMContentLoaded — which is
// what initPacdora/initPacdoraPlus hook into.
function bootstrapPacdora() {
  if (!window.PRODUCT_DATA || !window.PACDORA_CONFIG || !window.PACDORA_CONFIG.appId) {
    return
  }
  if (window.PACDORA_MODE === 'advanced') {
    initPacdoraPlus()
  } else {
    initPacdora()
  }
}

bootstrapPacdora()
